import { createApp } from 'vue';
import App from './App.vue';
import { setupRouter } from '@/router';
import { setupDirective } from './directive';
import { setupStore } from './store';
// import { setupComponents } from './components';
import '@/design';
// import "@/utils/font";
// import VConsole from 'vconsole';
import { setupTracker } from './utils/tracker';
import { loadAudioSource } from './utils/audio';


// new VConsole({ theme: 'dark' });


async function bootstrap() {
    const app = createApp(App);

    // Configure store
    setupStore(app);

    // Multilingual configuration
    // await setupI18n(app);

    // Configure routing
    setupRouter(app);

    // Configure directive
    setupDirective(app);

    // Configure Vant Component
    // setupComponents(app);

    // Configure Tracker
    setupTracker();

    loadAudioSource();

    app.mount('#app');
}

bootstrap();